import client from "./client";

// 로그인
export const login = loginData => client.post("/api/auth/login", loginData);
export const logout = () => client.get("/api/auth/logout");

// 현재 로그인 상태 확인
// export const check = () => client.get("/api/auth/check");

// 아이디 찾기
export const findId = data => client.post("/api/register/findUserId", data);

// 비밀번호 찾기
export const findPw = data => client.post("/api/register/findUserPwd", data);

// 비밀번호 변경
export const changePw = data => client.post("/api/register/changePwd", data);

// 회원탈퇴
export const withdraw = data => client.post("/api/register/withdraw", data);

// 자바 세션 체크
export const checkSession = () => client.get("/api/auth/logined");
